"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDestinationPage = void 0;
var UserDestinationPage;
(function (UserDestinationPage) {
    UserDestinationPage["LOGIN"] = "LOGIN";
    UserDestinationPage["HALO_LOGIN"] = "HALO_LOGIN";
    UserDestinationPage["ACCOUNT_SELECTION"] = "ACCOUNT_SELECTION";
    UserDestinationPage["PASSCODE_VALIDATION"] = "PASSCODE_VALIDATION";
    UserDestinationPage["NONE"] = "NONE";
    UserDestinationPage["DONE"] = "DONE";
    UserDestinationPage["POSTAUTHERROR"] = "POSTAUTHERROR";
})(UserDestinationPage = exports.UserDestinationPage || (exports.UserDestinationPage = {}));
//# sourceMappingURL=GetUserCurrentStateResponse.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/response/GetUserCurrentStateResponse.js
// module id = 378
// module chunks = 8